import { render, staticRenderFns } from "./WorkPeriodTemplatePage.vue?vue&type=template&id=310307d8&scoped=true&"
import script from "./WorkPeriodTemplatePage.vue?vue&type=script&lang=ts&"
export * from "./WorkPeriodTemplatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310307d8",
  null
  
)

export default component.exports